///<reference path="../common/custom-validation.model.ts"/>
///<reference path="../common/custom-validation-base.ts"/>
///<reference path="../collections/report-payroll-employees.collection.ts"/>

module Meevo.Components.Controls.SmartMover {

    export class PayrollEmployeesValidation extends CustomValidationBase implements ICustomValidation {
        get placement(): ErrorMessagePlacements {
            return 'top';
        }

        get message(): string {
            return 'ERROR_USER_IS_NOT_IN_PAYROLL';
        }

        get valid(): boolean {
            if (this.getAllSelected())
                return true;

            return this.employees.connectedModel.length > 0;
        }

        constructor(private employees: ReportPayrollEmployeesCollection, private getAllSelected: () => boolean) {
            super();
        }
    }
}